import React, { FC, useMemo } from 'react';
import { Button, Skeleton } from 'src/common';
import styles from './index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProfileType } from '@tendium/prom-types';
import { useLoadAllMpsIds } from 'src/models/matchingProfiles/hooks';
import { faBarsFilter, faSparkles } from '@fortawesome/pro-light-svg-icons';
import classNames from 'classnames';

interface Props {
  onClick: (id: string) => void;
  type: ProfileType;
  className?: string;
  activeId?: string;
  skip?: boolean;
  title?: string;
}
const MatchingProfilesList: FC<Props> = ({ onClick, type, skip, className, activeId, title }) => {
  const { data: profileData, loading: loadingProfile } = useLoadAllMpsIds(skip, type);
  const profiles = useMemo(() => profileData?.getAllMyMatchingProfiles ?? [], [profileData?.getAllMyMatchingProfiles]);

  return loadingProfile ? (
    <Skeleton active loading />
  ) : !!profiles.length ? (
    <div className={classNames(styles.list, className)}>
      {title && <span className={styles.title}>{title}</span>}
      {profiles.map(profile => (
        <Button
          key={profile.id}
          isActive={activeId === profile.id}
          onClick={() => onClick(profile.id)}
          type={'link'}
          className={styles.item}
          icon={
            <FontAwesomeIcon
              className={styles.icon}
              icon={profile.profileType === ProfileType.ExpiringContract ? faBarsFilter : faSparkles}
            />
          }
        >
          {profile.name}
        </Button>
      ))}
    </div>
  ) : (
    <></>
  );
};

export default MatchingProfilesList;
